export enum ShipmentsTypes {
  GET_SHIPMENTS = '@@shipments/GET_SHIPMENTS',
  GET_SHIPMENTS_SUCCESS = '@@shipments/GET_SHIPMENTS_SUCCESS',
  GET_SHIPMENTS_FAIL = '@@shipments/GET_SHIPMENTS_FAIL',

  GET_MILESTONESCONFIG_SH = "@SH/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_SH_SUCCESSS = "@SH/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_SH_FAIL = "@SH/GET_MILESTONECONFIG_FAIL",

  GET_MILESTONESEVENTSNAME_SH = "@SH/GET_MILESTONESEVENTSNAME_SH",
  GET_MILESTONESEVENTSNAME_SH_SUCCESSS = "@SH/GET_MILESTONESEVENTSNAME_SH_SUCCESS",
  GET_MILESTONESEVENTSNAME_SH_FAIL = "@SH/GET_MILESTONESEVENTSNAME_SH_FAIL",

  GET_MILESTONESEVENTSNAME_BYGUID_SH = "@SH/GET_MILESTONESEVENTSNAME_BYGUID_SH_SH",
  GET_MILESTONESEVENTSNAME_BYGUID_SH_SUCCESSS = "@SH/GET_MILESTONESEVENTSNAME_BYGUID_SH_SUCCESS",
  GET_MILESTONESEVENTSNAME_BYGUID_SH_FAIL = "@SH/GET_MILESTONESEVENTSNAME_BYGUID_SH_FAIL",
  
  GET_SHIPMENTS_HOUSES = '@@shipments/GET_SHIPMENTS_HOUSES',
  GET_SHIPMENTS_HOUSES_SUCCESS = '@@shipments/GET_SHIPMENTS_HOUSES_SUCCESS',
  GET_SHIPMENTS_HOUSES_FAIL = '@@shipments/GET_SHIPMENTS_HOUSES_FAIL',
}
